   <template>
    <div :id="id" :title="selectedOptionsText" class="location-picker">
      <b-row v-if="!!label" class="mb-2">
        <b-col><strong>{{ label }}</strong></b-col>
      </b-row>
      <div class="picker-dropdown border w-100 rounded d-flex justify-content-between p-2 align-items-center" @click="toggleOptions">
        <div class="selected-options">{{ selectedOptions.length }} opciones seleccionadas</div>
        <i class="fas" :class="{'fa-chevron-up': showOptions, 'fa-chevron-down': !showOptions}"></i>
      </div>
      <div class="picker-options" v-if="showOptions">
        <b-row class="mb-2">
          <b-col>
            <b-btn variant="link" @click="selectAll">Todos</b-btn> |
            <b-btn @click="clearSelection" variant="link">Ninguno</b-btn>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <input type="text" v-model="searchQuery" placeholder="Buscar..." class="form-control" />
          </b-col>
        </b-row>
        <div class="locations-list">
          <b-form-checkbox-group v-model="selectedOptions">
            <b-row>
              <b-col cols="12" md="6" v-for="(option, index) in filteredOptions" :key="`${id}-${index}`" class="mb-2">
                <b-form-checkbox :value="option[valueField]">
                  <div class="location-info">
                    {{ option[textField] }}
                    <p class="address" v-if="showAddress">{{ option[addressField] }}</p>
                  </div>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-checkbox-group>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      textField: {
        type: String,
        default: 'name',
      },
      valueField: {
        type: String,
        default: 'id',
      },
      addressField: {
        type: String,
        default: 'address',
      },
      showAddress: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        default: () => `picker-${Math.random() * 100000000}`,
      },
      value: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
      },
    },
    data: () => ({
      selectedOptions: [],
      showOptions: true,
      searchQuery: '', // Nueva propiedad para la búsqueda
    }),
    watch: {
      selectedOptions(val) {
        this.$emit('input', this.selectedOptions);
      },
    },
    computed: {
      selectedOptionsText() {
        return this.options
          .filter((option) => this.selectedOptions.includes(option[this.valueField]))
          .map((option) => option[this.textField])
          .join(', ');
      },
      filteredOptions() {
        // Filtra las opciones basadas en el texto de búsqueda
        return this.options.filter(option =>
          option[this.textField].toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      },
    },
    methods: {
      toggleOptions() {
        this.showOptions = !this.showOptions;
      },
      selectAll() {
        this.selectedOptions = this.options.map((item) => item[this.valueField]);
      },
      clearSelection() {
        this.selectedOptions = [];
      },
    },
  };
  </script>
  
  <style scoped>
  .location-picker {
    position: relative;
  }
  
  .picker-dropdown {
    height: 40px;
    background-color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #ddd;
  }
  
  .picker-options {
    position: absolute;
    width: 100%;
    max-width: 800px;
    z-index: 999;
    background-color: white;
    border: 1px solid lightgray;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    top: 100%;
    left: 0;
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .locations-list {
    max-height: 400px;
  }
  
  .location-info {
    display: flex;
    flex-direction: column;
  }
  
  .address {
    font-size: 0.9em;
    color: rgba(39, 39, 39, 0.699);
    font-weight: bold;
    margin-top: 5px;
  }
  
  .selected-options {
    max-width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  </style>